import React, { Fragment } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { selectChannelPopup } from "../store/selectors";
import { doCloseChannelPopup, doUpdateLayoutAndCells, doSetLayoutUpdateAvailability } from '../store/actions/channelLayout';
import { doRoute } from '../store/actions/location';
import { selectNewestAlert } from '../store/selectors/alerts';

import classnames from 'classnames'
import styles from './ChannelPopup.module.scss'
import { ROUTE_ACTIONS } from '../store/routes';

export default function ChannelPopup() {
  const channelPopup = useSelector(selectChannelPopup);
  const newestAlert = useSelector(selectNewestAlert);
  const dispatch = useDispatch();

  let popupOpen = channelPopup !== "none";

  let title: string | undefined;
  let description: string | undefined;
  let cancelButton: {
    title: string,
    action: (e: React.MouseEvent) => void
  } | undefined;
  let okayButton: {
    title: string,
    action: (e: React.MouseEvent) => void
  } | undefined;

  switch(channelPopup) {
    case "updatePrompt":
      title = "A channel update is available.";
      description = "Would you like to update it now?"
      cancelButton = {
        title: "No",
        action: (e) => dispatch(doCloseChannelPopup())
      }
      okayButton = {
        title: "Yes",
        action: (e) => {
          dispatch(doUpdateLayoutAndCells());
          dispatch(doSetLayoutUpdateAvailability(false));
        }
      }
      break;
    case "alertPrompt":
      title = "Alert (" + newestAlert.board.name + ")";
      description = newestAlert.message;
      cancelButton = {
        title: "Close",
        action: (e) => dispatch(doCloseChannelPopup())
      }
      okayButton = {
        title: "View Now",
        action: (e) => {
          dispatch(doRoute(ROUTE_ACTIONS.CHANNEL,{payload: {id: newestAlert.board.id}, query: {pan: newestAlert.cell.id?.toString()}}));
          dispatch(doCloseChannelPopup());
        }
      }
  }

  return (popupOpen ?
    <div className={styles.popup}>
      { title && <div className={styles.title}>{ title }</div> }
      { description && <div className={styles.description}>{ description }</div> }
      <div className={styles.actions}>
        { cancelButton && <button className={classnames(styles.button, styles.button_cancel)} onClick={cancelButton.action}>{ cancelButton.title }</button>}
        { okayButton && <button className={classnames(styles.button, styles.button_ok)} onClick={okayButton.action}>{ okayButton.title }</button>}
      </div>
    </div> : <Fragment />
  )
}